import type { IconComponent } from '@iheartjane/reefer';
import { Flex, Typography } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

export interface TileProps {
  /** Class name to apply to the tile */
  className?: string;

  /** Icon that will show up above the label */
  icon?: IconComponent;

  /** Label is the content shown below the icon */
  label: ReactNode;
}

/**
 * Light gray tile with an optional icon above a label, used to display attributes like feelings or flavors
 */
export const Tile = ({ className, icon: Icon, label }: TileProps) => {
  return (
    <Flex
      className={className}
      alignItems="center"
      justifyContent="center"
      borderRadius="lg"
      background="grays-ultralight"
      p={16}
      gap={8}
      flexDirection="column"
      minWidth="0"
    >
      {Icon && <Icon color={null} />}
      <Typography textAlign="center">{label}</Typography>
    </Flex>
  );
};
